import { Navigate, useLocation } from "react-router-dom";
import usePageTitle from "@/hooks/usePageTitle";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import MobilePersonLandingPage from "./MobilePersonLandingPage";

export default function PersonIndexPage() {
  usePageTitle("/people/:pgaId", "People | Person Details");
  const location = useLocation();
  const { isCompactLayout: isMobile } = useIsCompactLayout();

  // Show mobile landing page for mobile devices
  if (isMobile) {
    return <MobilePersonLandingPage />;
  }

  // Redirect to person for desktop
  return <Navigate to={`${location.pathname}/person`} replace state={location.state} />;
}
